// src/components/Navbar.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaSearch, FaArrowRight, FaArrowLeft, FaShoppingCart } from 'react-icons/fa';
import { VscAccount } from "react-icons/vsc";
import { useNavigate } from 'react-router-dom';

import CartSidebar from './cartslider';
import SearchBar from './searchbar';
import Logo from "../public/AfricFreshLogo-01.svg";
import Ifnoprofilepicture from "../public/ifnoprofilepicture.jpg"

import axios from 'axios';

const Navbar = ({ cartCount = 0, updateCartCount, forceUpdateProducts }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [history, setHistory] = useState([]);
  const [sidebarContent, setSidebarContent] = useState('main');
  const [isAuthMenuOpen, setIsAuthMenuOpen] = useState(false);
  const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isUser, setIsUser] = useState(null);

  const navigate = useNavigate();

  // Scroll effect for navbar
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleCartSidebar = () => {
    setIsCartOpen(!isCartOpen);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleCategoryClick = () => {
    setHistory([...history, sidebarContent]);
    setSidebarContent('categories');
  };

  const toggleAuthMenu = () => {
    setIsAuthMenuOpen(!isAuthMenuOpen);
  };

  const toggleAccountMenu = () => {
    setIsAccountMenuOpen(!isAccountMenuOpen);
  };

  const handleSubCategoryClick = (category) => {
    setHistory([...history, sidebarContent]);
    setSidebarContent(category);
  };

  const handleBackClick = () => {
    const newHistory = [...history];
    const previousContent = newHistory.pop();
    setHistory(newHistory);
    setSidebarContent(previousContent || 'main');
  };

  useEffect(() => {
    const checkTokenExpiration = () => {
      const token = localStorage.getItem('AficFreshtoken');
      const expiresAt = localStorage.getItem('AficFreshExpiresAt');
      const user = localStorage.getItem('AficFreshuserDetails');

      if (!token || !expiresAt) {
        handleLogout();
        return;
      }

      const now = new Date().getTime();
      const expirationTime = new Date(expiresAt).getTime();

      if (now >= expirationTime) {
        handleLogout();
        return;
      }

      if (user) {
        const parsedUser = JSON.parse(user);
        setIsUser(parsedUser);
        setIsLoggedIn(true);

        const timeUntilExpiry = expirationTime - now;
        if (timeUntilExpiry > 0) {
          setTimeout(() => {
            handleLogout();
          }, timeUntilExpiry);
        }
      } else {
        setIsLoggedIn(false);
      }
    };

    checkTokenExpiration();

    return () => {
      let id = setTimeout(() => {}, 0);
      while (id) {
        clearTimeout(id);
        id--;
      }
    };
  }, []);

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

// Replace your current fetchUserData useEffect with this:
useEffect(() => {
  const fetchUserData = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('AficFreshtoken');
      
      if (!token) {
        setLoading(false);
        return;
      }

      const response = await axios.get(
        `https://afric-fresh-backend.onrender.com/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (response.data) {
        setIsLoggedIn(true);
        setUser(response.data);
        localStorage.setItem('AficFreshuserDetails', JSON.stringify(response.data));
      }
      
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error('Error fetching user data:', err);
    }
  };

  // Only fetch if we have a token and user isn't already loaded
  const token = localStorage.getItem('AficFreshtoken');
  if (token && !user) {
    fetchUserData();
  }
}, [user]); // Add user as dependency

  const handleLogout = () => {
    localStorage.removeItem('AficFreshtoken');
    localStorage.removeItem('AficFreshExpiresAt');
    localStorage.removeItem('AficFreshuserDetails');
    setIsLoggedIn(false);
    setIsUser(null);
    setIsAccountMenuOpen(false);
  }




  const renderAuthSection = () => {
    if (isLoggedIn && isUser) {
      return (
        <div className="relative">
          <button 
            className="text-[#007D44] max-sm:p-0 max-sm:py-2 p-2 hover:bg-[#007D44]/10 rounded-lg flex items-center transition-all duration-300 hover:scale-105 active:scale-95"
            onClick={toggleAccountMenu}
          >
            <div className="hidden sm:flex items-center space-x-2 pr-1">
              <h1 className="text-sm animate-fade-in">
                Welcome back <span className="uppercase animate-bounce-subtle">{isUser.firstName}</span>
              </h1>
            </div>
  
            <VscAccount size={30} className="transition-transform duration-300 hover:rotate-12" />
            <svg xmlns="http://www.w3.org/2000/svg" className={`h-4 w-4 ml-2 transform transition-all duration-500 ease-in-out ${isAccountMenuOpen ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
  
          {isAccountMenuOpen && (
            <div className="absolute right-0 mt-2 w-80 bg-white rounded-2xl shadow-2xl z-50 overflow-hidden transform transition-all duration-500 ease-out animate-dropdown-in">
              <div className="px-6 py-3 text-gray-600 border-b bg-gray-50 sm:hidden animate-slide-down">
                <span className="text-sm font-medium">Welcome back,</span>
                <span className="uppercase font-semibold ml-1">{isUser.firstName}</span>
              </div>

              <div className="p-6 bg-gradient-to-r from-[#007D44]/10 to-white border-b animate-gradient-x">
                <div className="flex items-center space-x-4">
                {user?.profilepicture ? (
                    <div className="w-20 h-20 rounded-full overflow-hidden ring-4 ring-white shadow-lg animate-float">
                      <img 
                        src={user.profilepicture                       } 
                        alt="Profile"
                        className="w-full h-full object-cover rounded-full transform hover:scale-110 transition-transform duration-500"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.parentElement.innerHTML = `
                            <div class="w-full h-full bg-gray-100 flex items-center justify-center">
                              <span class="text-gray-400 text-sm">No Photo</span>
                            </div>`;
                        }}
                      />
                    </div>
                  ) : (
                    <div className="w-20 h-20 bg-gray-100 flex items-center justify-center ring-4 ring-white shadow-lg rounded-full animate-pulse-gentle">
                      <img src={Ifnoprofilepicture} className="w-20 h-20 rounded-full object-contain hover:scale-110 transition-transform duration-500" alt="Default Profile" />
                    </div>
                  )}

                  
                  <div className="flex flex-col">
                    <span className="text-lg font-bold text-gray-800 animate-slide-right">
                      {isUser.firstName} {isUser.lastName}
                    </span>
                    <button 
                      onClick={handleLogout}
                      className="mt-2 text-sm font-medium text-red-500 hover:text-red-600 flex items-center space-x-1 transition-all duration-300 hover:translate-x-2 group"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M3 3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H3zm11 4.414l-4.293 4.293a1 1 0 0 1-1.414-1.414L12.586 6H8a1 1 0 1 1 0-2h7a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0V7.414z" />
                      </svg>
                      <span>Sign Out</span>
                    </button>
                  </div>
                </div>
              </div>

              <div className="py-2">
                {[
                  { to: "/account/dashboard", icon: "🎯", label: "Dashboard" },
                  { to: "/account/orders", icon: "📦", label: "My Orders" },
                  { to: "/account/favourite", icon: "❤️", label: "Favourite" },
                  { to: "/account/payment", icon: "💳", label: "Payment" },
                ].map((item, index) => (
                  <Link
                    key={index}
                    to={item.to}
                    className="flex items-center px-6 py-3 text-gray-700 hover:bg-[#007D44]/5 transition-all duration-300 group animate-slide-up"
                    style={{ animationDelay: `${index * 100}ms` }}
                  >
                    <span className="mr-3 text-xl animate-bounce-icon">{item.icon}</span>
                    <span className="font-medium group-hover:text-[#007D44] transition-colors duration-300">
                      {item.label}
                    </span>
                    <svg
                      className="w-5 h-5 ml-auto text-gray-400 group-hover:text-[#007D44] transition-all duration-300 transform group-hover:translate-x-2 group-hover:scale-110"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path d="M9 5l7 7-7 7"></path>
                    </svg>
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <>
          <div className="hidden sm:flex items-center space-x-2 lg:space-x-4">
            <Link to="/auth/login">
              <button className="text-[#007D44] font-medium px-3 py-2 hover:bg-[#007D44]/10 rounded-lg transition-all duration-300 hover:scale-105 active:scale-95 hover:shadow-lg">
                Log in
              </button>
            </Link>
            <Link to="/auth/signup">
              <button className="bg-[#007D44] text-white px-4 py-2 rounded-full font-medium hover:bg-[#007D44]/90 transition-all duration-300 hover:scale-105 active:scale-95 hover:shadow-xl animate-pulse-button">
                Sign up
              </button>
            </Link>
          </div>
    
          <div className="sm:hidden relative">
            <button 
              className="text-[#007D44] p-2 hover:bg-[#007D44]/10 rounded-lg transition-all duration-300 hover:scale-110 active:scale-95"
              onClick={toggleAuthMenu}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 transition-transform duration-300 hover:rotate-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </button>
    
            {isAuthMenuOpen && (
              <div className="absolute right-0 mt-2 w-40 bg-white rounded-lg shadow-lg z-50 animate-dropdown-in">
                <Link to="/auth/login" className="block px-4 py-2 text-[#007D44] hover:bg-[#007D44]/10 transition-all duration-300 hover:translate-x-2">
                  Log in
                </Link>
                <Link to="/auth/signup" className="block px-4 py-2 text-[#007D44] hover:bg-[#007D44]/10 transition-all duration-300 hover:translate-x-2">
                  Sign up
                </Link>
              </div>
            )}
          </div>
        </>
      );
    }
  };

  const renderSidebarContent = () => {
    switch (sidebarContent) {
      case 'main':
        return (
          <ul className="text-[#007D44] text-left max-sm:pl-0 text-xl z-[999] w-full">
            {[
              { type: 'button', onClick: handleCategoryClick, text: 'Categories', hasArrow: true, size: 'text-2xl' },
              { type: 'link', to: '/', text: 'Home page' },
              { type: 'link', to: '/order', text: 'Order page' },
              { type: 'link', to: '/discounts', text: 'Discount' },
              { type: 'link', to: '/Blog', text: 'Blog page' },
              { type: 'link', to: '/aboutus', text: 'About page' },
              { type: 'link', to: '/contactform', text: 'Contact' },
              { type: 'link', to: '/privacypolicy', text: 'Privacy page' },
              { type: 'link', to: '/termscondition', text: 'Terms of service' },
            ].map((item, index) => (
              <li key={index} className="mb-7 animate-slide-right w-full" style={{ animationDelay: `${index * 100}ms` }}>
                {item.type === 'button' ? (
                  <button onClick={item.onClick} className={`underline-animation header ${item.size || ''} categories-link hover:scale-105 transition-transform duration-300`}>
                    {item.text}
                    {item.hasArrow && <FaArrowRight className="arrow-animation inline ml-0" />}
                  </button>
                ) : (
                  <Link to={item.to} className="underline-animation header hover:scale-105 transition-transform duration-300 hover:text-[#007D44]/80">
                    {item.text}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        );
      case 'categories':
        return (
          <div>
            <button onClick={handleBackClick} className="text-[#007D44] text-2xl mb-4 hover:scale-110 transition-transform duration-300 animate-slide-right">
              <FaArrowLeft />
            </button>
            <ul className="text-[#007D44] text-left max-sm:pl-0 text-xl">
              {[
                { onClick: () => handleSubCategoryClick('nonPerishable'), text: 'Non-perishable' },
                { onClick: () => handleSubCategoryClick('perishable'), text: 'Perishable' },
              ].map((item, index) => (
                <li key={index} className="mb-7 text-xl max-sm:flex max-md:justify-between animate-slide-up" style={{ animationDelay: `${index * 150}ms` }}>
                  <button onClick={item.onClick} className="underline-animation categories-link hover:scale-105 transition-transform duration-300">
                    {item.text}
                    <FaArrowRight className="arrow-animation inline ml-2" />
                  </button>
                </li>
              ))}
            </ul>
          </div>
        );
      case 'nonPerishable':
        return (
          <div>
            <button onClick={handleBackClick} className="text-[#007D44] text-2xl mb-1 hover:scale-110 transition-transform duration-300 animate-slide-right">
              <FaArrowLeft />
            </button>
            <ul className="text-[#007D44] text-left max-sm:pl-0 text-xl overflow-auto h-auto">
              {[
                { to: '/category/grain', text: 'GRAINS' },
                { to: '/category/flour', text: 'FLOUR' },
                { to: '/category/oil', text: 'OIL' },
                { to: '/category/spices', text: 'SPICES/SEASONING' },
                { to: '/category/paste', text: 'PASTE' },
                { to: '/category/beauty', text: 'BEAUTY' },
                { to: '/category/beverages', text: 'BEVERAGES/SNACKS' },
                { to: '/category/canned', text: 'CANNED FOOD' },
                { to: '/category/seafoods', text: 'SEA FOODS' },
                { to: '/category/vegetables', text: 'VEGETABLES' },
                { to: '/category/fruits', text: 'FRUITS' },
                { to: '/category/ethnic', text: 'ETHNIC GROCERIES' },
                { to: '/category/africansponge', text: 'AFRICAN SPONGE' },
              ].map((item, index) => (
                <li key={index} className="mb-3 animate-slide-up hover:translate-x-2 transition-transform duration-300" style={{ animationDelay: `${index * 50}ms` }}>
                  <Link to={item.to} className="text-[#007D44] underline-animation hover:scale-105 transition-transform duration-300">
                    {item.text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        );
      case 'perishable':
        return (
          <div>
            <button onClick={handleBackClick} className="text-[#007D44] text-xl mb-4 hover:scale-110 transition-transform duration-300 animate-slide-right">
              <FaArrowLeft />
            </button>
            <ul className="text-[#007D44] pl-[150px] max-sm:text-left max-sm:pl-0 text-xl">
              {[
                { to: '/meat', text: 'Meat (coming soon)' },
                { to: '/fish', text: 'Fish (coming soon)' },
                { to: '/fresh-produce', text: 'Fresh Produce (coming soon)' },
              ].map((item, index) => (
                <li key={index} className="mb-5 animate-slide-up hover:translate-x-2 transition-transform duration-300" style={{ animationDelay: `${index * 100}ms` }}>
                  <Link to={item.to} className="underline-animation hover:scale-105 transition-transform duration-300">
                    {item.text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className='fixed top-0 left-0 w-full z-50'>
      <nav className={`bg-[#F2E7DB] shadow p-4 transition-all duration-500 ${isScrolled ? 'shadow-xl backdrop-blur-sm bg-[#F2E7DB]/95' : ''}`}>
        <div className="flex items-center justify-between max-w-7xl mx-auto">
          <div className="flex items-center space-x-5 lg:space-x-4">
            <button 
              onClick={toggleSidebar} 
              className="text-[#007D44] text-2xl p-2 hover:bg-[#007D44]/10 rounded-lg transition-all duration-300 hover:scale-110 active:scale-95 hover:rotate-180"
            >
              <FaBars />
            </button>
            <div className="h-12 w-full max-sm:w-52 flex items-center ml-10 mr-16 max-sm:ml-3 max-sm:mr-0">
              <Link to="/" className="hover:scale-105 transition-transform duration-300">
                <img src={Logo} alt="Logo" className="h-20 w-48 max-sm:w-52 max-sm:h-32 animate-float" />
              </Link>
            </div>
          </div>

          <div className="flex-grow justify-center items-center ml-10 hidden lg:flex mx-4-w-2xl">
            <div className="animate-slide-down">
              <SearchBar />
            </div>
          </div>

          <div className="flex items-center space-x-0 lg:space-x-4">
            {renderAuthSection()}

            <button 
              onClick={toggleCartSidebar} 
              className="relative p-2 text-[#34a536] hover:bg-[#a4e8a5]/20 rounded-full transition-all duration-300 hover:scale-110 active:scale-95 animate-bounce-cart"
            >
              <FaShoppingCart className="text-2xl" />
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 w-6 h-6 flex items-center justify-center text-xs font-bold text-white bg-[#007D44] rounded-full border-2 border-[#93f594] animate-pulse-count">
                  {cartCount}
                </span>
              )}
            </button>
          </div> 
        </div>

        <div className="lg:hidden flex mt-4 px-4 max-sm:flex animate-slide-up">
          <SearchBar />
        </div>
      </nav>

      <div className={`fixed inset-0 bg-[#F2E7DB] bg-opacity-50 z-auto transition-all duration-500 ${isSidebarOpen ? 'opacity-100 backdrop-blur-sm' : 'opacity-0 pointer-events-none'}`} onClick={toggleSidebar}></div>
      <div className={`fixed top-0 left-0 w-[320px] max-w-full bg-[#F2E7DB] h-full transform transition-all duration-500 ease-out ${isSidebarOpen ? 'translate-x-0 shadow-2xl' : '-translate-x-full'}`}>
        <div className="p-4">
          <button className="text-[#007D44] text-5xl mb-4 hover:scale-110 hover:rotate-90 transition-all duration-300" onClick={toggleSidebar}>
            &times;
          </button>
          {renderSidebarContent()}
        </div>
      </div>

      <CartSidebar 
        isOpen={isCartOpen} 
        onClose={toggleCartSidebar} 
        updateCartCount={updateCartCount} 
        forceUpdateProducts={forceUpdateProducts} 
      />

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes slideRight {
          from { opacity: 0; transform: translateX(-30px); }
          to { opacity: 1; transform: translateX(0); }
        }

        @keyframes slideUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes slideDown {
          from { opacity: 0; transform: translateY(-30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes dropdownIn {
          from { 
            opacity: 0; 
            transform: translateY(-20px) scale(0.95); 
          }
          to { 
            opacity: 1; 
            transform: translateY(0) scale(1); 
          }
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-5px); }
        }

        @keyframes bounceSubtle {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-2px); }
        }

        @keyframes bounceIcon {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }

        @keyframes bounceCart {
          0%, 100% { transform: scale(1); }
          25% { transform: scale(1.05) rotate(-5deg); }
          75% { transform: scale(1.05) rotate(5deg); }
        }

        @keyframes pulseGentle {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.02); opacity: 0.9; }
        }

        @keyframes pulseButton {
          0%, 100% { box-shadow: 0 0 0 0 rgba(0, 125, 68, 0.4); }
          50% { box-shadow: 0 0 0 10px rgba(0, 125, 68, 0); }
        }

        @keyframes pulseCount {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.2); }
        }

        @keyframes gradientX {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }

        .animate-fade-in { animation: fadeIn 0.6s ease-out; }
        .animate-slide-right { animation: slideRight 0.6s ease-out; }
        .animate-slide-up { animation: slideUp 0.6s ease-out; }
        .animate-slide-down { animation: slideDown 0.6s ease-out; }
        .animate-dropdown-in { animation: dropdownIn 0.5s ease-out; }
        .animate-float { animation: float 3s ease-in-out infinite; }
        .animate-bounce-subtle { animation: bounceSubtle 2s ease-in-out infinite; }
        .animate-bounce-icon { animation: bounceIcon 2s ease-in-out infinite; }
        .animate-bounce-cart { animation: bounceCart 2s ease-in-out infinite; }
        .animate-pulse-gentle { animation: pulseGentle 2s ease-in-out infinite; }
        .animate-pulse-button { animation: pulseButton 2s ease-in-out infinite; }
        .animate-pulse-count { animation: pulseCount 1s ease-in-out infinite; }
        .animate-gradient-x { 
          background-size: 200% 200%;
          animation: gradientX 3s ease infinite;
        }

        .underline-animation {
          position: relative;
          overflow: hidden;
        }

        .underline-animation::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: -100%;
          width: 100%;
          height: 2px;
          background: #007D44;
          transition: left 0.5s ease;
        }

        .underline-animation:hover::after {
          left: 0;
        }

        .arrow-animation {
          transition: transform 0.3s ease;
        }

        .categories-link:hover .arrow-animation {
          transform: translateX(5px);
        }
      `}</style>
    </div>
  );
};

export default Navbar;